import { cy, gd, ga } from '../langs';

function getTranslations(lang: string) {
    const dictionary: { [name: string]: string } = {};
    let poFile: string | null = null;
    if (lang === 'gd') {
        poFile = gd;
    }
    if (lang === 'cy') {
        poFile = cy;
    }
    if (lang === 'ga') {
        poFile = ga;
    }
    if (poFile) {
        const lines = poFile
            .split('\n')
            .map((l) => l.trim())
            .filter((l) => !l.startsWith('#'))
            .filter((l) => !l.startsWith('"'))
            .filter((l) => l.length > 0);

        for (let l = 0; l < lines.length; l += 2) {
            let msgid = lines[l].replace('msgid "', '');
            msgid = msgid.substring(0, msgid.length - 1).replace(/\\"/g, '"');
            let msgstr = lines[l + 1].replace('msgstr "', '');
            msgstr = msgstr.substring(0, msgstr.length - 1).replaceAll(/\\"/g, '"');
            if (msgid && msgstr) {
                dictionary[msgid] = msgstr;
            }
        }
    }
    return dictionary;
}

const dictionary = ref<{ [name: string]: string }>({});

export default function (lang: Ref<string>) {
    watch(
        lang,
        (newValue, oldValue) => {
            if (newValue !== oldValue) {
                dictionary.value = getTranslations(lang.value);
            }
        },
        { immediate: true },
    );

    return {
        get: (val: string, ...args: (string | number)[]) => {
            let result = dictionary.value[val] || val;
            // if (lang.value !== 'en' && result === val) {
            //     console.log(`Missing ${lang.value} translation for ${val}`);
            // }
            for (const arg of args) {
                result = result.replace('%s', arg + '');
            }
            return result;
        },
        language: lang,
    };
}
